/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  ErrorArchivedPlugin,
  IErrorArchivedPluginMethods,
  HeaderArchivedPlugin,
  IHeaderArchivedPluginMethods,
  LoadingArchivedPlugin,
  ILoadingArchivedPluginMethods,
  ArchivedListPlugin,
  IArchivedListPluginMethods,
  SettingsArchivedPlugin,
  ISettingsArchivedPluginMethods,
  StaticArchivedPagePlugin,
  IStaticArchivedPagePluginMethods,
} from './plugins';

export type TAgent = IErrorArchivedPluginMethods &
  IHeaderArchivedPluginMethods &
  ILoadingArchivedPluginMethods &
  IArchivedListPluginMethods &
  ISettingsArchivedPluginMethods &
  IStaticArchivedPagePluginMethods;

const getPlugins = () => {
  return [
    new StaticArchivedPagePlugin(),
    new ErrorArchivedPlugin(),
    new LoadingArchivedPlugin(),
    //Business logic plugins !
    new HeaderArchivedPlugin(),
    new ArchivedListPlugin(),
    new SettingsArchivedPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
